import DOMPurify from "dompurify";

function sanitizeDrupalHtml(html?: string): string {
  if (!html) return "";

  return DOMPurify.sanitize(html, {
    USE_PROFILES: {
      html: true,
    },
    FORBID_TAGS: [
      "script",
      "iframe",
      "object",
      "embed",
      "form",
      "input",
      "button",
      "textarea",
      "select",
      "option",   
      "meta",
      "link",
      "base",
    ],
    FORBID_ATTR: [
      "srcdoc",
      "formaction",
    ],
    ADD_ATTR: [
    "target",
    "rel",
    "title",
    ],
    ALLOW_DATA_ATTR: true,
    ALLOW_ARIA_ATTR: true,
  });
}

export default sanitizeDrupalHtml;